export default __webpack_public_path__ + "f4c205c54173bffef79fbc53ef75bc2f.png";